import React, {useState, useContext} from 'react';
import Slide1 from './slides/main/Slide1';
import Slide2 from './slides/main/Slide2';
import Slide3 from './slides/main/Slide3';
import Slide4 from './slides/main/Slide4';
import Slide5 from './slides/main/Slide5';
import Slide6 from './slides/main/Slide6';
import Slide7 from './slides/main/Slide7';
import Slide8 from './slides/main/Slide8';
import Slide9 from './slides/main/Slide9';
import SignUp from '../../../api/auth/signUp';
import {GlobalContext} from '../../../utilities/GlobalContext';
import slideSystem from './slideSystem';

function ExportSlides() {
	let serverOrigin = useContext(GlobalContext).serverOrigin;
	let user = useContext(GlobalContext).user;
	let setUser = useContext(GlobalContext).setUser;
	let slides = [Slide1, Slide2, Slide3, Slide4, Slide5, Slide6, Slide7, Slide8, Slide9];
	let mainSlides = slideSystem(slides, {
		done: done,
		next: next,
	});

	return mainSlides;

	function next(userFrag, options = {}) {
		let userBuffer = user || {};
		for (let property in userFrag) {
			userBuffer[property] = userFrag[property];
			setUser(userBuffer);
		}
		if (options.createUser) {
			let user = cleanUser(userBuffer);
			SignUp(user, setUser, serverOrigin);
		}
	}
	function done() {
		window.location.href = '/home';
	}
	function cleanUser(inUser) {
		let user = {
			name: {
				first: inUser.name.first || 'error',
				last: inUser.name.last || null,
			},
			email: inUser.email || 'error',
		};

		user.a1 = inUser.a1 || null;
		user.a2 = inUser.a2 || null;
		user.a3 = inUser.a3 || null;
		user.a4 = inUser.a4 || null;
		user.age = inUser.age || null;
		user.listOfGoals = inUser.listOfGoals || null;

		return user;
	}
}

export default ExportSlides;
